import { render, staticRenderFns } from "./DicomViewerButton.vue?vue&type=template&id=768f47fa&"
import script from "./DicomViewerButton.vue?vue&type=script&lang=js&"
export * from "./DicomViewerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports